
export default [
  {
    path: '/',
    // Relative to /src/views
    name: 'Dashboard',
    view: 'Dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/reset-pass',
    name: 'Reset Password',
    view: 'ResetPass',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/logout',
    name: 'Logout'
  },
  {
    path: '/programari',
    name: 'Programari',
    view: 'Programari',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/programare/:id',
    name: 'Editare Programare',
    view: 'ProgramareEdit',
    query: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profil',
    name: 'Profil',
    view: 'Profil',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/factinfo',
    name: 'Informatii de facturare',
    view: 'MyAddress',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/seo',
    name: 'Optimizare cautare',
    view: 'MySeo',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pacienti',
    name: 'Pacienti',
    view: 'Pacienti',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pacient/:id',
    name: 'Pacient',
    view: 'Pacient',
    query: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/interventie/:id',
    name: 'Interventie',
    view: 'Interventie',
    query: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cabinet',
    name: 'Cabinet',
    view: 'Cabinet',
    meta: {
      requiresAuth: true
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/paths.js